import { EntityId } from 'entities-next/common'
import { Corporate } from 'entities-next/corporate'
import { SearchFunction } from 'entities-next/searchFunctions'
import { FinderStageId, Stage } from 'entities-next/stages'
import { User } from 'entities-next/user'

import { Analysis } from '../analyses/analyses.types'
import { Organization, OrganizationSource } from '../organizations/types'

export type DealsState = {
  readonly isFetching: boolean
  readonly items: IdIndexedDeals
}

export type IdIndexedDeals = Partial<{
  readonly [dealId: number]: Deal
}>

export type Deal = {
  readonly id: number
  readonly organizationId: Organization['id']
  readonly userId: User['id']
  readonly corporateId: Corporate['id']
  readonly trackOrganization: boolean
  readonly referrerId: number
  readonly currentFunnelStageId: Stage['id']
  readonly currentFinderStage?: FinderStageId
  readonly currentStageReason?: DealReason[]
  readonly lastInteractionAt?: string | null
  readonly notes?: string
  readonly receivedOn: string
  readonly isValid?: boolean | null
  readonly isValidUpdatedAt?: string
  readonly fitReason?: string
  readonly fitScore?: number
  readonly fitUrl?: string
  readonly passed: boolean
  readonly source: OrganizationSource
  readonly onHold: boolean
  readonly fitsWithRelaxedCriteria: boolean
  readonly isCalibration: boolean
  readonly analysis: Analysis
} & WithSearchFunctions &
  WithCorporate

export type WithSearchFunctions = {
  readonly searchFunctionId?: EntityId
  readonly searchFunction?: SearchFunction
}

export type WithCorporate = {
  readonly corporate?: Corporate
}

export type DealReason = {
  key: string
  content?: string
}

export type DealInfoData = {
  notes?: Deal['notes']
  receivedOn: Deal['receivedOn']
  source: Deal['source']
}

export type DealEmail = {
  from: string
  to: string[]
  bcc: string[]
  cc: string[]
  subject: string
  body: string
  dealId: number
}

export const DEALS_STORE_ID = 'deals'

export enum DealTransition {
  SEND_TO_INVESTOR = 'SEND_TO_INVESTOR',
}
